import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const listInvitationsStart = createAction(
  'LIST_INVITATIONS::START',
  withPayloadType<{ organizationId: string }>(),
);
